import Collections from './collections';

export { Collections };

export default Collections;
